import { axios } from '@/plugins/axios';
import { Event } from '@/models/Event';

export class EventService {
  endpoint: string;

  constructor() {
    this.endpoint = 'v1/events/';
  }

  async createEvent(event: Event): Promise<any> {
    return axios.post(`${this.endpoint}`, event).then(res => res.data as Event);
  }

  async fetchEvents(): Promise<any> {
    return axios.get(`${this.endpoint}`).then(res => res.data as Event[]);
  }

  async getEvent(id: string): Promise<any> {
    return axios.get(`${this.endpoint}${id}`).then(({ data }) => data);
  }

  async updateEvent(id: string, event: Event): Promise<any> {
    return axios
      .patch(`${this.endpoint}${id}/`, event)
      .then(res => res.data as Event);
  }

  async deleteEvent(id: string): Promise<any> {
    return axios
      .delete(`${this.endpoint}${id}/`)
      .then(res => res.data as Event);
  }

  //TODO: find out why options is not found
  async optionsEvent(id: string): Promise<any> {
    return axios({ method: 'options', url: `${this.endpoint}${id}/` }).then(
      (res: any) => res.data as any
    );
  }

  async optionsListEvent(): Promise<any> {
    return axios({ method: 'options', url: `${this.endpoint}` }).then(
      (res: any) => res.data
    );
  }
}
